import React from "react";
import { Row, Col } from "reactstrap";
import "./buyFlowNew.scss";
import InnerShadowButton from "../../../components/common/buttons/innerShadow";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AxiosReactClient from "../../../utilities/AxiosRestClient";
// import "react-datepicker/dist/react-datepicker.css";
import InsuranceCard from "../../../components/common/cards/InsuranceCard";
import * as moment from "moment";
import ButtonWithSubHeading from "../../../components/common/buttons/buttonWithSubHeading";
import Cookies from "js-cookie";
import YesNoQuestion from "../../../components/common/buyflow/yesNoQuestion";
import CustomInput from "../../../components/common/buyflow/inputs/CustomTextInput";
import MultiSelectQuestion from "../../../components/common/buyflow/multiSelectQuestion";
import SingleSelectQuestion from "../../../components/common/buyflow/singleSelectQuestion";
import CustomTextInput from "../../../components/common/buyflow/inputs/CustomTextInput";
import CustomHeightInput from "../../../components/common/buyflow/inputs/CustomHeightInput";

class BuyFlowNew extends React.Component {
  constructor(props) {
    super(props);
    // console.log(Cookies.get("dob"));
    this.state = {
      currentScreen: 1,
      checked: true,
      selected: ["self", "spouse"],
      selectedMaritalStatus: ["married"],
      selectedEducation: ["post_graduation"],
      salutation: "mr",
      name: Cookies.get("name") ? Cookies.get("name") : "",
      dob: Cookies.get("dob")
        ? new Date(Cookies.get("dob"))
        : new Date("Sun Jan 01 1995 15:35:21 GMT+0530 (India Standard Time)"),
      email: Cookies.get("email") ? Cookies.get("email") : "",
      phone: Cookies.get("mobile") ? Cookies.get("mobile") : "",
      age: "31",
      toffeeId: "XXXX XXXX XXXX",
      cardType: "nominee",
      fromDate: "31 Jan, 2010",
      nomineeName: "Sneha Gupta",
      nomineeSalutation: "mrs",
      nomineeDob: new Date(
        "Sun Jan 01 1995 15:35:21 GMT+0530 (India Standard Time)"
      ),
      nomineePhone: "+91 98765 43210",
      nomineeRelation: "wife",
      step: 0,
      pincode: "122018",
      // city: 'Gurgaon',
      cityState: "Gurgaon, Haryana",
      address1: "4th floor Tower-C",
      address2: "Unitech Businesszone, Sector 50",

      selectedPlan: props.match.params["plan"],

      errors: {
        name: "",
        email: "",
        dob: "",
        phone: "",
      },
      submittingData: false,
    };
    if (!["single", "family"].includes(props.match.params["plan"])) {
      props.history.push("/");
    }
  }
  emailPattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  );

  inputGroup = [];

  componentDidMount() {
    window.scrollTo(0, 0);
  }
  changeInput(data, input) {
    // console.log(input, " : ", data);
    let errors = this.state.errors;
    switch (input) {
      case "salutation":
        this.setState({
          salutation: data,
        });
        break;
      case "name":
        this.setState({
          name: data,
        });
        errors.name = this.validateInput("name", data);
        break;
      case "dob":
        this.setState({
          dob: data,
        });
        errors.dob = this.validateInput("dob", data);
        break;
      case "email":
        this.setState({
          email: data,
        });
        errors.email = this.validateInput("email", data);
        break;
      case "phone":
        this.setState({
          phone: data,
        });
        errors.phone = this.validateInput("phone", data);
        break;
      default:
        break;
    }
    this.setState({ errors }, () => {
      // console.log(errors);
    });
  }
  validateInput(input, data) {
    switch (input) {
      case "name":
        if (!data) {
          return "Name cannot be empty";
        }
        break;
      case "dob":
        // console.log(this.getAgeInYears(data));
        if (!data) {
          return "DOB cannot be empty";
        }
        if (this.getYears(data) < 18) {
          return "Age should be more than 18 Years";
        }
        break;
      case "email":
        if (!data) {
          return "Email cannot be empty";
        }
        if (!this.emailPattern.test(data)) {
          return "Invalid Email Address";
        }
        break;
      case "phone":
        if (!data) {
          return "Mobile cannot be empty";
        }
        if (data.length !== 10) {
          return "Mobile should be exact 10 digits";
        }
        break;
      default:
        break;
    }
  }
  changeNomineeInput(data, input) {
    // console.log(input, " : ", data);
    switch (input) {
      case "salutation":
        this.setState({
          nomineeSalutation: data,
        });
        break;
      case "name":
        this.setState({
          nomineeName: data,
        });
        break;
      case "dob":
        this.setState({
          nomineeDob: data,
        });
        break;
      case "relation":
        this.setState({
          nomineeRelation: data,
        });
        break;
      case "phone":
        this.setState({
          nomineePhone: data,
        });
        break;
      default:
        break;
    }
  }
  changeAddressInput(data, input) {
    // console.log(input, " : ", data);
    switch (input) {
      case "pincode":
        this.setState({
          pincode: data,
        });
        break;
      case "state-city":
        this.setState({
          cityState: data,
        });
        break;
      case "address1":
        this.setState({
          nomineeDob: data,
        });
        break;
      case "address2":
        this.setState({
          nomineeRelation: data,
        });
        break;
      default:
        break;
    }
  }
  getAgeInYears(dob) {
    console.log(dob);
    return dob
      ? moment.duration(moment(new Date()).diff(moment(dob))).years() + " Years"
      : 0;
  }
  getYears(dob) {
    return dob
      ? moment.duration(moment(new Date()).diff(moment(dob))).years()
      : 0;
  }

  addLead() {
    let errors = this.state.errors;
    if (this.state.name.trim() === "") {
      errors.name = "Name field cannot be empty";
    }
    if (!this.state.dob || this.state.dob.toString().trim() === "") {
      errors.dob = "DOB cannot be empty";
    }
    if (this.state.email.trim() === "") {
      errors.email = "Email field cannot be empty";
    }
    if (this.state.phone.trim() === "") {
      errors.phone = "Phone field cannot be empty";
    }
    this.setState({ errors });
    if (errors.name || errors.email || errors.dob || errors.phone) {
      return;
    }
    this.setState({
      submittingData: true,
    });

    return;
    AxiosReactClient.postRequestWithoutToken("life/leads", {
      name: this.state.name,
      email: this.state.email,
      mobile: this.state.phone,
      dob: moment(this.state.dob).format("DD/MM/YYYY"),
      title: this.state.salutation,
      plan: this.state.selectedPlan,
    })
      .then((response) => {
        this.setState({
          submittingData: false,
        });
        // alert("Submitted successfully");
        this.props.history.push(
          "/product/" + this.state.selectedPlan + "/success"
        );
      })
      .catch((err) => {
        this.setState({
          submittingData: false,
        });
        console.log(err);
      });
  }

  //

  moveToNextScreen() {
    if (this.state.currentScreen > 7) {
      this.props.history.push(
        "/product/" + this.state.selectedPlan + "/success"
      );
    } else {
      this.setState({
        currentScreen: this.state.currentScreen + 1,
      });
    }
  }

  getTitle() {
    if (this.state.currentScreen < 4) {
      return "Details of Prakash Gupta";
    }

    switch (this.state.currentScreen) {
      case 4:
        return "Details of your spouse";
        break;
      case 5:
        return "Details of your child";
        break;
      case 6:
        return "Nominee details";
        break;
      case 7:
        return "Home Address";
        break;
      case 8:
        return "Review and Pay";
        break;
      default:
        return "";
    }
    if (this.state.currentScreen === 4) {
      return "Details of your spouse";
    }
    if (this.state.currentScreen === 5) {
      return "Details of your child";
    }
  }

  getDateInLocalFormat(date) {
    var local = new Date(date);
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
  }
  render() {
    return (
      <div className="buyflowNew-container">
        <div className="header d-flex justify-content-between">
          <h3 className="font-weight-bold m-0">{this.getTitle()}</h3>
          <i class={"fas fa-phone  fa-md "} color="danger" />
        </div>

        {/* Screen One */}
        {this.state.currentScreen === 1 && (
          <div className="screen screen-one">
            <h3 className="font-weight-bold mb-34 mb-mobile-34">
              Prakash, let’s get to know you better?
            </h3>
            <h3 className="mb-24 mb-mobile-24">Enter your height and weight</h3>
            <p>input fields</p>
            <hr />
            <SingleSelectQuestion
              title="Marital Status"
              // subTitle="Select family members you want to insure (for Health) under your Family Toffee Plan"
              checked={this.state.checked}
              onAnswered={(selectedArray) => {
                this.setState({
                  selectedMaritalStatus: selectedArray,
                });
              }}
              options={[
                {
                  title: "Single",
                  value: "single",
                },
                {
                  title: "Married",
                  value: "married",
                },
                {
                  title: "Divorced",
                  value: "divorced",
                },
                {
                  title: "Widowed",
                  value: "widowed",
                },
              ]}
              selected={this.state.selectedMaritalStatus}
            />
            <hr />
            <SingleSelectQuestion
              title="Select highest education"
              // subTitle="Select family members you want to insure (for Health) under your Family Toffee Plan"
              checked={this.state.checked}
              onAnswered={(selectedArray) => {
                this.setState({
                  selectedEducation: selectedArray,
                });
              }}
              options={[
                {
                  title: "Post Graduate",
                  value: "post_graduate",
                },
                {
                  title: "Graduate",
                  value: "draduate",
                },
                {
                  title: "Diploma",
                  value: "diploma",
                },
                {
                  title: "10th",
                  value: "10th",
                },
                {
                  title: "12th",
                  value: "12th",
                },
                {
                  title: "Below 10th",
                  value: "below_10th",
                },
              ]}
              selected={this.state.selectedEducation}
            />
            <hr />
            <h3 className="font-weight-bold">Permanent Account Number (PAN)</h3>
            <CustomInput inputType="text" placeholder="Enter PAN here" />
          </div>
        )}
        {/* Screen Two */}

        {this.state.currentScreen === 2 && (
          <div className="screen screen-one ">
            <YesNoQuestion
              title="Are you a politically exposed person?"
              checked={this.state.checked}
              onAnswered={(value) => {
                console.log(value);
                this.setState({
                  checked: value,
                });
              }}
            />
            <hr />
            <YesNoQuestion
              title="Type of Occupation"
              subTitle="Is your current occupation associated with any occupational hazard or do you take part in activities or have hobbies that could be life risking in any way?"
              checked={this.state.checked}
              onAnswered={(value) => {
                console.log(value);
                this.setState({
                  checked: value,
                });
              }}
            />
            <hr />

            <YesNoQuestion
              title="Are you employed in the armed, para military or police forces?"
              checked={this.state.checked}
              onAnswered={(value) => {
                console.log(value);
                this.setState({
                  checked: value,
                });
              }}
            />
          </div>
        )}
        {/* Screen Three */}
        {this.state.currentScreen === 3 && (
          <div className="screen screen-three">
            <YesNoQuestion
              title="Do you consume or ever consumed alcohol?"
              checked={this.state.checked}
              onAnswered={(value) => {
                console.log(value);
                this.setState({
                  checked: value,
                });
              }}
            />
            <hr />
            <YesNoQuestion
              title="Do you consume or ever consumed narcotics (Drugs)?"
              checked={this.state.checked}
              onAnswered={(value) => {
                console.log(value);
                this.setState({
                  checked: value,
                });
              }}
            />
            <hr />
          </div>
        )}

        {/* Screen Four */}
        {this.state.currentScreen === 4 && (
          <div className="screen screen-four">
            <h3 className="font-weight-bold mb-34 mb-mobile-34">
              Share the details of your spouse to be included in Health
              Insurance
            </h3>
            <div className="prefix-div">
              <div
                className={
                  this.state.salutation === "mr"
                    ? "prefix-name active"
                    : "prefix-name"
                }
                onClick={(e) => {
                  this.changeInput("mr", "salutation");
                }}
              >
                <h4 className="m-0 p-0">Mr</h4>
              </div>
              <div
                className={
                  this.state.salutation === "ms"
                    ? "prefix-name active"
                    : "prefix-name"
                }
                onClick={(e) => {
                  this.changeInput("ms", "salutation");
                }}
              >
                <h4 className="m-0 p-0">Ms</h4>
              </div>
              <div
                className={
                  this.state.salutation === "mrs"
                    ? "prefix-name active"
                    : "prefix-name"
                }
                onClick={(e) => {
                  this.changeInput("mrs", "salutation");
                }}
              >
                <h4 className="m-0 p-0">Mrs</h4>
              </div>
            </div>

            <CustomTextInput inputType="text" placeholder="Full Name" />
            <CustomTextInput inputType="date" placeholder="Date of Birth" />
            <CustomHeightInput />
            <CustomTextInput
              inputType="number"
              placeholder="Enter Weight (kg)"
            />
          </div>
        )}
        {/* Screen Five */}
        {this.state.currentScreen === 5 && (
          <div className="screen screen-five">
            <h3 className="font-weight-bold mb-34 mb-mobile-34">
              Share the details of your daughter to be included in Health
              Insurance
            </h3>

            <CustomTextInput inputType="text" placeholder="Full Name" />
            <CustomTextInput inputType="date" placeholder="Date of Birth" />
            <CustomHeightInput />
            <CustomTextInput
              inputType="number"
              placeholder="Enter Weight (kg)"
            />
          </div>
        )}
        {/* Screen Six */}
        {this.state.currentScreen === 6 && (
          <div className="screen screen-six">
            <h3 className="font-weight-bold mb-34 mb-mobile-34">
              Add Nominee details
            </h3>
            <p>input fields</p>
          </div>
        )}

        {/* Screen Seven */}
        {this.state.currentScreen === 7 && (
          <div className="screen screen-seven">
            <h3 className="font-weight-bold mb-34 mb-mobile-34">
              Home address to be insured
            </h3>
            <p>input fields</p>
          </div>
        )}

        {/* Screen Eight */}
        {this.state.currentScreen === 8 && (
          <div className="screen screen-eight">
            <h3 className="font-weight-bold mb-34 mb-mobile-34">
              Please review your details
            </h3>
            <p>Details</p>
          </div>
        )}

        <div className="footer d-flex justify-content-end">
          <InnerShadowButton
            clicked={(e) => {
              this.moveToNextScreen();
            }}
            title="Next"
            active={true}
          />
        </div>
      </div>
    );
  }
}

export default BuyFlowNew;
